<template>
  <div class="w-full">
    <cabecera-web></cabecera-web>
    <formulario-altas></formulario-altas>
  </div>
</template>
<script>
import FormularioAltas from "@/components/FormularioComprobar";
// import FormularioAltas from '@/components/FormularioAltaDenda'
import CabeceraWeb from "@/components/Cabecera2";
export default {
  components: {
    FormularioAltas,
    CabeceraWeb,
  },
  mounted() {
    this.$store.dispatch("getBono", "bizkaia");
  },
};
</script>